// Animation system for the futuristic UI redesign
// Defines keyframes, durations, and timing functions

// CSS keyframes for animations
export const keyframes = {
  fadeIn: {
    '0%': { opacity: '0' },
    '100%': { opacity: '1' },
  },
  fadeOut: {
    '0%': { opacity: '1' },
    '100%': { opacity: '0' },
  },
  scaleIn: {
    '0%': { transform: 'scale(0.95)', opacity: '0' },
    '100%': { transform: 'scale(1)', opacity: '1' },
  },
  scaleOut: {
    '0%': { transform: 'scale(1)', opacity: '1' },
    '100%': { transform: 'scale(0.95)', opacity: '0' },
  },
  slideInBottom: {
    '0%': { transform: 'translateY(20px)', opacity: '0' },
    '100%': { transform: 'translateY(0)', opacity: '1' },
  },
  slideInTop: {
    '0%': { transform: 'translateY(-20px)', opacity: '0' },
    '100%': { transform: 'translateY(0)', opacity: '1' },
  },
  slideInRight: {
    '0%': { transform: 'translateX(20px)', opacity: '0' },
    '100%': { transform: 'translateX(0)', opacity: '1' },
  },
  slideInLeft: {
    '0%': { transform: 'translateX(-20px)', opacity: '0' },
    '100%': { transform: 'translateX(0)', opacity: '1' },
  },
  pulse: {
    '0%, 100%': { opacity: '1' },
    '50%': { opacity: '0.5' },
  },
  glow: {
    '0%, 100%': { boxShadow: '0 0 5px rgba(77, 97, 252, 0.5)' },
    '50%': { boxShadow: '0 0 20px rgba(77, 97, 252, 0.8)' },
  },
  shimmer: {
    '0%': { backgroundPosition: '-1000px 0' },
    '100%': { backgroundPosition: '1000px 0' },
  },
  spin: {
    '0%': { transform: 'rotate(0deg)' },
    '100%': { transform: 'rotate(360deg)' },
  },
  float: {
    '0%, 100%': { transform: 'translateY(0)' },
    '50%': { transform: 'translateY(-5px)' },
  },
  countdown: {
    '0%': { width: '100%' },
    '100%': { width: '0%' },
  },
};

// Animation durations and timing functions
export const animation = {
  duration: {
    fastest: '100ms',
    faster: '150ms',
    fast: '200ms',
    normal: '300ms',
    slow: '400ms',
    slower: '500ms',
    slowest: '700ms',
  },
  timing: {
    ease: 'cubic-bezier(0.25, 0.1, 0.25, 1.0)',
    easeIn: 'cubic-bezier(0.42, 0, 1.0, 1.0)',
    easeOut: 'cubic-bezier(0, 0, 0.58, 1.0)',
    easeInOut: 'cubic-bezier(0.42, 0, 0.58, 1.0)',
    spring: 'cubic-bezier(0.25, 0.1, 0.1, 1.5)',
  },
};

// Glass effect utilities
export const glassmorphism = {
  '.glass': {
    background: 'rgba(255, 255, 255, 0.1)',
    'backdrop-filter': 'blur(10px)',
    border: '1px solid rgba(255, 255, 255, 0.1)',
    'box-shadow': '0 8px 32px rgba(0, 0, 0, 0.1)',
  },
  '.glass-dark': {
    background: 'rgba(0, 0, 0, 0.2)',
    'backdrop-filter': 'blur(10px)',
    border: '1px solid rgba(255, 255, 255, 0.05)',
    'box-shadow': '0 8px 32px rgba(0, 0, 0, 0.2)',
  },
};
